import { compile } from "path-to-regexp";
export var Endpoint;
(function (Endpoint) {
    Endpoint["AcceptFeesSelf"] = "AcceptFeesSelf";
    Endpoint["AcceptMerchantAgreementSelf"] = "AcceptMerchantAgreementSelf";
    Endpoint["AccessTokenCreate"] = "AccessTokenCreate";
    Endpoint["AccessTokenList"] = "AccessTokenList";
    Endpoint["AccessTokenSelf"] = "AccessTokenSelf";
    Endpoint["AccessTokenUpdate"] = "AccessTokenUpdate";
    Endpoint["AccessTokenDisable"] = "AccessTokenDisable";
    Endpoint["AccountUpgradeTokenCreate"] = "AccountUpgradeTokenCreate";
    Endpoint["ActivationDiscountVersionList"] = "ActivationDiscountVersionList";
    Endpoint["AddressDetailSelf"] = "AddressDetailSelf";
    Endpoint["AddressLookupCreate"] = "AddressLookupCreate";
    Endpoint["AdminAccessTokenCreate"] = "AdminAccessTokenCreate";
    Endpoint["AdminAppRevenueShareAgreementCreate"] = "AdminAppRevenueShareAgreementCreate";
    Endpoint["AdminAppRevenueShareAgreementSelf"] = "AdminAppRevenueShareAgreementSelf";
    Endpoint["AdminBankAccountBlacklist"] = "AdminBankAccountBlacklist";
    Endpoint["AdminCommentCreate"] = "AdminCommentCreate";
    Endpoint["AdminCommentUpdate"] = "AdminCommentUpdate";
    Endpoint["AdminCommentList"] = "AdminCommentList";
    Endpoint["AdminCreditorUpdateMerchantCategoryCode"] = "AdminCreditorUpdateMerchantCategoryCode";
    Endpoint["AdminCreditorUpdateSubtype"] = "AdminCreditorUpdateSubtype";
    Endpoint["AdminCreditorUpdateOnlinePresenceUrl"] = "AdminCreditorUpdateOnlinePresenceUrl";
    Endpoint["AdminCreditorDetailSelf"] = "AdminCreditorDetailSelf";
    Endpoint["AdminFraudMetricsSelf"] = "AdminFraudMetricsSelf";
    Endpoint["AdminFraudMetricsBankNetworkList"] = "AdminFraudMetricsBankNetworkList";
    Endpoint["AdminFraudMetricsFraudScoresList"] = "AdminFraudMetricsFraudScoresList";
    Endpoint["AdminFraudMetricsIpAddressesList"] = "AdminFraudMetricsIpAddressesList";
    Endpoint["AdminFraudMetricsIpAddressesNetworkList"] = "AdminFraudMetricsIpAddressesNetworkList";
    Endpoint["AdminFraudMetricsMandatesList"] = "AdminFraudMetricsMandatesList";
    Endpoint["AdminFraudMetricsMonthlyMandateSummaryList"] = "AdminFraudMetricsMonthlyMandateSummaryList";
    Endpoint["AdminFraudMetricsPaymentOverviewList"] = "AdminFraudMetricsPaymentOverviewList";
    Endpoint["AdminSearchSearch"] = "AdminSearchSearch";
    Endpoint["AdminTaskList"] = "AdminTaskList";
    Endpoint["AdminTaskTrigger"] = "AdminTaskTrigger";
    Endpoint["AmlAlertTriggerTypeList"] = "AmlAlertTriggerTypeList";
    Endpoint["AmlScoreSelf"] = "AmlScoreSelf";
    Endpoint["AppList"] = "AppList";
    Endpoint["AppSelf"] = "AppSelf";
    Endpoint["AppCreate"] = "AppCreate";
    Endpoint["AppUpdate"] = "AppUpdate";
    Endpoint["AppRequestReview"] = "AppRequestReview";
    Endpoint["AppApprove"] = "AppApprove";
    Endpoint["AppDisable"] = "AppDisable";
    Endpoint["AppNonOauthEnabled"] = "AppNonOauthEnabled";
    Endpoint["AppAccessTokenCreate"] = "AppAccessTokenCreate";
    Endpoint["AppAuthorisationRevoke"] = "AppAuthorisationRevoke";
    Endpoint["AppAuthorisationSelf"] = "AppAuthorisationSelf";
    Endpoint["AppAuthorisationList"] = "AppAuthorisationList";
    Endpoint["AppFeeAgreementSelf"] = "AppFeeAgreementSelf";
    Endpoint["AppFeeAgreementList"] = "AppFeeAgreementList";
    Endpoint["AppFeeAgreementCreate"] = "AppFeeAgreementCreate";
    Endpoint["AuthenticationFactorList"] = "AuthenticationFactorList";
    Endpoint["AuthenticationFactorSelf"] = "AuthenticationFactorSelf";
    Endpoint["AuthenticationFactorCreate"] = "AuthenticationFactorCreate";
    Endpoint["AuthenticationFactorTrigger"] = "AuthenticationFactorTrigger";
    Endpoint["AuthenticationFactorVerify"] = "AuthenticationFactorVerify";
    Endpoint["AuthenticationFactorDisable"] = "AuthenticationFactorDisable";
    Endpoint["AuthenticationFactorDisableOrgUser"] = "AuthenticationFactorDisableOrgUser";
    Endpoint["AuthorisationLinkList"] = "AuthorisationLinkList";
    Endpoint["AuthorisationRequestCreate"] = "AuthorisationRequestCreate";
    Endpoint["AuthorisationRequestList"] = "AuthorisationRequestList";
    Endpoint["AuthorisationRequestCancel"] = "AuthorisationRequestCancel";
    Endpoint["AvailableCreditorRefundAmountList"] = "AvailableCreditorRefundAmountList";
    Endpoint["AvailableEventDetailsList"] = "AvailableEventDetailsList";
    Endpoint["BalanceList"] = "BalanceList";
    Endpoint["BankAccountDetailSelf"] = "BankAccountDetailSelf";
    Endpoint["BankAccountUpdateRequestCreate"] = "BankAccountUpdateRequestCreate";
    Endpoint["BankAccountUpdateRequestInitialise"] = "BankAccountUpdateRequestInitialise";
    Endpoint["BankAccountUpdateRequestComplete"] = "BankAccountUpdateRequestComplete";
    Endpoint["BankAccountUpdateRequestDetails"] = "BankAccountUpdateRequestDetails";
    Endpoint["BankAccountUpdateRequestShow"] = "BankAccountUpdateRequestShow";
    Endpoint["BankAuthorisationCreate"] = "BankAuthorisationCreate";
    Endpoint["BankAuthorisationSelf"] = "BankAuthorisationSelf";
    Endpoint["BankAuthorisationLookup"] = "BankAuthorisationLookup";
    Endpoint["BankAuthorisationAuthorise"] = "BankAuthorisationAuthorise";
    Endpoint["BankAuthorisationExit"] = "BankAuthorisationExit";
    Endpoint["BankAuthorisationTrackVisit"] = "BankAuthorisationTrackVisit";
    Endpoint["BankDetailsLookupCreate"] = "BankDetailsLookupCreate";
    Endpoint["BankNetworkMetricsSelf"] = "BankNetworkMetricsSelf";
    Endpoint["BillingContactList"] = "BillingContactList";
    Endpoint["BillingContactSelf"] = "BillingContactSelf";
    Endpoint["BillingContactCreate"] = "BillingContactCreate";
    Endpoint["BillingContactUpdate"] = "BillingContactUpdate";
    Endpoint["BillingRedirectFlowCreate"] = "BillingRedirectFlowCreate";
    Endpoint["BillingRedirectFlowComplete"] = "BillingRedirectFlowComplete";
    Endpoint["BillingRequestCreate"] = "BillingRequestCreate";
    Endpoint["BillingRequestCollectCustomerDetails"] = "BillingRequestCollectCustomerDetails";
    Endpoint["BillingRequestCollectBankAccount"] = "BillingRequestCollectBankAccount";
    Endpoint["BillingRequestConfirmPayerDetails"] = "BillingRequestConfirmPayerDetails";
    Endpoint["BillingRequestFulfil"] = "BillingRequestFulfil";
    Endpoint["BillingRequestCancel"] = "BillingRequestCancel";
    Endpoint["BillingRequestList"] = "BillingRequestList";
    Endpoint["BillingRequestSelf"] = "BillingRequestSelf";
    Endpoint["BillingRequestNotify"] = "BillingRequestNotify";
    Endpoint["BillingRequestFallback"] = "BillingRequestFallback";
    Endpoint["BillingRequestChooseCurrency"] = "BillingRequestChooseCurrency";
    Endpoint["BillingRequestUpdate"] = "BillingRequestUpdate";
    Endpoint["BillingRequestSelectInstitution"] = "BillingRequestSelectInstitution";
    Endpoint["BillingRequestCreateWithActions"] = "BillingRequestCreateWithActions";
    Endpoint["BillingRequestCollectAmount"] = "BillingRequestCollectAmount";
    Endpoint["BillingRequestFlowCreate"] = "BillingRequestFlowCreate";
    Endpoint["BillingRequestFlowSelf"] = "BillingRequestFlowSelf";
    Endpoint["BillingRequestFlowInitialise"] = "BillingRequestFlowInitialise";
    Endpoint["BillingRequestFlowResume"] = "BillingRequestFlowResume";
    Endpoint["BillingRequestFlowTrack"] = "BillingRequestFlowTrack";
    Endpoint["BillingRequestFlowExit"] = "BillingRequestFlowExit";
    Endpoint["BillingRequestTemplateList"] = "BillingRequestTemplateList";
    Endpoint["BillingRequestTemplateSelf"] = "BillingRequestTemplateSelf";
    Endpoint["BillingRequestTemplateCreate"] = "BillingRequestTemplateCreate";
    Endpoint["BillingRequestTemplateUpdate"] = "BillingRequestTemplateUpdate";
    Endpoint["BillingRequestTemplateUse"] = "BillingRequestTemplateUse";
    Endpoint["BlockCreate"] = "BlockCreate";
    Endpoint["BlockSelf"] = "BlockSelf";
    Endpoint["BlockList"] = "BlockList";
    Endpoint["BlockDisable"] = "BlockDisable";
    Endpoint["BlockEnable"] = "BlockEnable";
    Endpoint["BlockBlockByRef"] = "BlockBlockByRef";
    Endpoint["BrowserPerformanceMetricCreate"] = "BrowserPerformanceMetricCreate";
    Endpoint["BulkChangeRequestCreate"] = "BulkChangeRequestCreate";
    Endpoint["CapitalIntegrationList"] = "CapitalIntegrationList";
    Endpoint["ChargebackSelf"] = "ChargebackSelf";
    Endpoint["ChargebackList"] = "ChargebackList";
    Endpoint["ChargebackSubmit"] = "ChargebackSubmit";
    Endpoint["ChargebackChallengeCreate"] = "ChargebackChallengeCreate";
    Endpoint["ChargebackChallengeSelf"] = "ChargebackChallengeSelf";
    Endpoint["ChargebackChallengeSubmit"] = "ChargebackChallengeSubmit";
    Endpoint["ChargebackEvidenceDelete"] = "ChargebackEvidenceDelete";
    Endpoint["ConnectBankAccountAisAuthorisationUrl"] = "ConnectBankAccountAisAuthorisationUrl";
    Endpoint["ConnectBankAccountAddUnmatchedBankAccount"] = "ConnectBankAccountAddUnmatchedBankAccount";
    Endpoint["ContractList"] = "ContractList";
    Endpoint["ContractCreate"] = "ContractCreate";
    Endpoint["CookieBasedTokenCreate"] = "CookieBasedTokenCreate";
    Endpoint["CreditorCreate"] = "CreditorCreate";
    Endpoint["CreditorList"] = "CreditorList";
    Endpoint["CreditorSelf"] = "CreditorSelf";
    Endpoint["CreditorUpdate"] = "CreditorUpdate";
    Endpoint["CreditorFlagAsRisky"] = "CreditorFlagAsRisky";
    Endpoint["CreditorCloseAccount"] = "CreditorCloseAccount";
    Endpoint["CreditorClearNegativeBalance"] = "CreditorClearNegativeBalance";
    Endpoint["CreditorCancelUnsubmittedPayments"] = "CreditorCancelUnsubmittedPayments";
    Endpoint["CreditorCancelAllSubscriptions"] = "CreditorCancelAllSubscriptions";
    Endpoint["CreditorChangePayoutIntervalSetting"] = "CreditorChangePayoutIntervalSetting";
    Endpoint["CreditorChangeFlexiblePayoutSettings"] = "CreditorChangeFlexiblePayoutSettings";
    Endpoint["CreditorRequestFlexiblePayoutOverride"] = "CreditorRequestFlexiblePayoutOverride";
    Endpoint["CreditorClearFlexiblePayoutOverride"] = "CreditorClearFlexiblePayoutOverride";
    Endpoint["CreditorChargeBackAllPayments"] = "CreditorChargeBackAllPayments";
    Endpoint["CreditorUpdateHoldingPeriod"] = "CreditorUpdateHoldingPeriod";
    Endpoint["CreditorUpdateMerchantCategoryCode"] = "CreditorUpdateMerchantCategoryCode";
    Endpoint["CreditorBalanceList"] = "CreditorBalanceList";
    Endpoint["CreditorBankAccountCreate"] = "CreditorBankAccountCreate";
    Endpoint["CreditorBankAccountList"] = "CreditorBankAccountList";
    Endpoint["CreditorBankAccountSelf"] = "CreditorBankAccountSelf";
    Endpoint["CreditorBankAccountDisable"] = "CreditorBankAccountDisable";
    Endpoint["CreditorDetailList"] = "CreditorDetailList";
    Endpoint["CreditorDetailSelf"] = "CreditorDetailSelf";
    Endpoint["CreditorDetailUpdate"] = "CreditorDetailUpdate";
    Endpoint["CreditorRestrictionList"] = "CreditorRestrictionList";
    Endpoint["CreditorRestrictionStatusList"] = "CreditorRestrictionStatusList";
    Endpoint["CreditorVerticalList"] = "CreditorVerticalList";
    Endpoint["CurrencyExchangeRateList"] = "CurrencyExchangeRateList";
    Endpoint["CustomPaymentPagePaymentFlowLookup"] = "CustomPaymentPagePaymentFlowLookup";
    Endpoint["CustomPaymentPageTrack"] = "CustomPaymentPageTrack";
    Endpoint["CustomerCreate"] = "CustomerCreate";
    Endpoint["CustomerList"] = "CustomerList";
    Endpoint["CustomerSelf"] = "CustomerSelf";
    Endpoint["CustomerUpdate"] = "CustomerUpdate";
    Endpoint["CustomerCancel"] = "CustomerCancel";
    Endpoint["CustomerRemove"] = "CustomerRemove";
    Endpoint["CustomerApprovalSelf"] = "CustomerApprovalSelf";
    Endpoint["CustomerApprovalGrant"] = "CustomerApprovalGrant";
    Endpoint["CustomerApprovalDeny"] = "CustomerApprovalDeny";
    Endpoint["CustomerBankAccountCreate"] = "CustomerBankAccountCreate";
    Endpoint["CustomerBankAccountList"] = "CustomerBankAccountList";
    Endpoint["CustomerBankAccountSelf"] = "CustomerBankAccountSelf";
    Endpoint["CustomerBankAccountUpdate"] = "CustomerBankAccountUpdate";
    Endpoint["CustomerBankAccountDisable"] = "CustomerBankAccountDisable";
    Endpoint["CustomerBankAccountTokenCreatePost"] = "CustomerBankAccountTokenCreatePost";
    Endpoint["CustomerBankAccountTokenSelf"] = "CustomerBankAccountTokenSelf";
    Endpoint["CustomerEmailVerificationCreate"] = "CustomerEmailVerificationCreate";
    Endpoint["CustomerEmailVerificationVerify"] = "CustomerEmailVerificationVerify";
    Endpoint["CustomerNotificationList"] = "CustomerNotificationList";
    Endpoint["CustomerNotificationHandle"] = "CustomerNotificationHandle";
    Endpoint["CustomerNotificationPermissionCreate"] = "CustomerNotificationPermissionCreate";
    Endpoint["CustomerNotificationPermissionUpdate"] = "CustomerNotificationPermissionUpdate";
    Endpoint["CustomerNotificationPermissionRevoke"] = "CustomerNotificationPermissionRevoke";
    Endpoint["CustomerNotificationPermissionList"] = "CustomerNotificationPermissionList";
    Endpoint["CustomerSearchSearch"] = "CustomerSearchSearch";
    Endpoint["DeveloperContactList"] = "DeveloperContactList";
    Endpoint["DeveloperContactCreate"] = "DeveloperContactCreate";
    Endpoint["DeveloperContactSelf"] = "DeveloperContactSelf";
    Endpoint["DeveloperContactUpdate"] = "DeveloperContactUpdate";
    Endpoint["DropinConfigurationList"] = "DropinConfigurationList";
    Endpoint["EmailVerificationCreate"] = "EmailVerificationCreate";
    Endpoint["EstimatePaymentFeeList"] = "EstimatePaymentFeeList";
    Endpoint["EstimatePayoutList"] = "EstimatePayoutList";
    Endpoint["EventList"] = "EventList";
    Endpoint["EventSelf"] = "EventSelf";
    Endpoint["EventSimulationTrigger"] = "EventSimulationTrigger";
    Endpoint["ExportSelf"] = "ExportSelf";
    Endpoint["ExportCreate"] = "ExportCreate";
    Endpoint["ExportList"] = "ExportList";
    Endpoint["FeeAgreementSelf"] = "FeeAgreementSelf";
    Endpoint["FeeAgreementList"] = "FeeAgreementList";
    Endpoint["FeeAgreementCreate"] = "FeeAgreementCreate";
    Endpoint["FeeAgreementDestroy"] = "FeeAgreementDestroy";
    Endpoint["FeeAgreementTemplateList"] = "FeeAgreementTemplateList";
    Endpoint["FeeDiscountList"] = "FeeDiscountList";
    Endpoint["FeeDiscountCreate"] = "FeeDiscountCreate";
    Endpoint["FlagsList"] = "FlagsList";
    Endpoint["FraudAlertTriggerTypeList"] = "FraudAlertTriggerTypeList";
    Endpoint["ImportList"] = "ImportList";
    Endpoint["ImportSelf"] = "ImportSelf";
    Endpoint["ImportCreate"] = "ImportCreate";
    Endpoint["ImportErrorFile"] = "ImportErrorFile";
    Endpoint["ImportRequestProcess"] = "ImportRequestProcess";
    Endpoint["ImportProcess"] = "ImportProcess";
    Endpoint["ImportCancel"] = "ImportCancel";
    Endpoint["ImportEntryList"] = "ImportEntryList";
    Endpoint["ImportTemplateCreate"] = "ImportTemplateCreate";
    Endpoint["ImportTemplateShow"] = "ImportTemplateShow";
    Endpoint["ImportUploadTokenCreate"] = "ImportUploadTokenCreate";
    Endpoint["InstalmentScheduleCreateWithDates"] = "InstalmentScheduleCreateWithDates";
    Endpoint["InstalmentScheduleCreateWithSchedule"] = "InstalmentScheduleCreateWithSchedule";
    Endpoint["InstalmentScheduleList"] = "InstalmentScheduleList";
    Endpoint["InstalmentScheduleSelf"] = "InstalmentScheduleSelf";
    Endpoint["InstalmentScheduleUpdate"] = "InstalmentScheduleUpdate";
    Endpoint["InstalmentScheduleCancel"] = "InstalmentScheduleCancel";
    Endpoint["InstalmentTemplateSelf"] = "InstalmentTemplateSelf";
    Endpoint["InstalmentTemplateList"] = "InstalmentTemplateList";
    Endpoint["InstalmentTemplateCreate"] = "InstalmentTemplateCreate";
    Endpoint["InstalmentTemplateSubscribe"] = "InstalmentTemplateSubscribe";
    Endpoint["InstitutionList"] = "InstitutionList";
    Endpoint["InstitutionListForBillingRequest"] = "InstitutionListForBillingRequest";
    Endpoint["IntelligentRetryStatisticList"] = "IntelligentRetryStatisticList";
    Endpoint["InvoicePdfCreate"] = "InvoicePdfCreate";
    Endpoint["IpNetworkMetricsSelf"] = "IpNetworkMetricsSelf";
    Endpoint["LogoCreateForCreditor"] = "LogoCreateForCreditor";
    Endpoint["LogoCreate"] = "LogoCreate";
    Endpoint["LogoSelf"] = "LogoSelf";
    Endpoint["MandateCreate"] = "MandateCreate";
    Endpoint["MandateList"] = "MandateList";
    Endpoint["MandateSelf"] = "MandateSelf";
    Endpoint["MandateUpdate"] = "MandateUpdate";
    Endpoint["MandateCancel"] = "MandateCancel";
    Endpoint["MandateReinstate"] = "MandateReinstate";
    Endpoint["MandateMove"] = "MandateMove";
    Endpoint["MandateFundsAvailability"] = "MandateFundsAvailability";
    Endpoint["MandateImportCreate"] = "MandateImportCreate";
    Endpoint["MandateImportSelf"] = "MandateImportSelf";
    Endpoint["MandateImportSubmit"] = "MandateImportSubmit";
    Endpoint["MandateImportCancel"] = "MandateImportCancel";
    Endpoint["MandateImportEntryCreate"] = "MandateImportEntryCreate";
    Endpoint["MandateImportEntryList"] = "MandateImportEntryList";
    Endpoint["MandateMigrationOptOut"] = "MandateMigrationOptOut";
    Endpoint["MandateMigrationOptIn"] = "MandateMigrationOptIn";
    Endpoint["MandateMigrationSelf"] = "MandateMigrationSelf";
    Endpoint["MandatePdfCreate"] = "MandatePdfCreate";
    Endpoint["MerchantCategoryCodePredict"] = "MerchantCategoryCodePredict";
    Endpoint["MfaEnforcementEnforce"] = "MfaEnforcementEnforce";
    Endpoint["NegativeBalanceLimitList"] = "NegativeBalanceLimitList";
    Endpoint["NegativeBalanceLimitCreate"] = "NegativeBalanceLimitCreate";
    Endpoint["OauthActiveFlowSelf"] = "OauthActiveFlowSelf";
    Endpoint["OauthCreateForOrganisationOauthCreateForOrganisation"] = "OauthCreateForOrganisationOauthCreateForOrganisation";
    Endpoint["OauthFeesSelf"] = "OauthFeesSelf";
    Endpoint["OauthListOrganisationsSelfOauthListOrganisationsSelf"] = "OauthListOrganisationsSelfOauthListOrganisationsSelf";
    Endpoint["OnboardingStepList"] = "OnboardingStepList";
    Endpoint["OnfidoSdkTokenCreate"] = "OnfidoSdkTokenCreate";
    Endpoint["OrganisationSelf"] = "OrganisationSelf";
    Endpoint["OrganisationUpdateSelf"] = "OrganisationUpdateSelf";
    Endpoint["OrganisationRequestPackage"] = "OrganisationRequestPackage";
    Endpoint["OrganisationChangePackage"] = "OrganisationChangePackage";
    Endpoint["OrganisationApplySchemeIdentifier"] = "OrganisationApplySchemeIdentifier";
    Endpoint["OrganisationRemoveSchemeIdentifier"] = "OrganisationRemoveSchemeIdentifier";
    Endpoint["OrganisationEnforceMfa"] = "OrganisationEnforceMfa";
    Endpoint["OrganisationAcceptTermsAndConditions"] = "OrganisationAcceptTermsAndConditions";
    Endpoint["OrganisationPublicKeyUrl"] = "OrganisationPublicKeyUrl";
    Endpoint["OrganisationProposedLink"] = "OrganisationProposedLink";
    Endpoint["OrganisationApproveProposedLink"] = "OrganisationApproveProposedLink";
    Endpoint["OrganisationRejectProposedLink"] = "OrganisationRejectProposedLink";
    Endpoint["OrganisationAuthorisationList"] = "OrganisationAuthorisationList";
    Endpoint["OrganisationBillingRequestCreate"] = "OrganisationBillingRequestCreate";
    Endpoint["OrganisationBillingRequestFulfil"] = "OrganisationBillingRequestFulfil";
    Endpoint["OutOfCycleReviewSelf"] = "OutOfCycleReviewSelf";
    Endpoint["OutOfCycleReviewUpdate"] = "OutOfCycleReviewUpdate";
    Endpoint["OutboundPaymentCreate"] = "OutboundPaymentCreate";
    Endpoint["OutboundPaymentWithdraw"] = "OutboundPaymentWithdraw";
    Endpoint["OutboundPaymentCancel"] = "OutboundPaymentCancel";
    Endpoint["OutboundPaymentApprove"] = "OutboundPaymentApprove";
    Endpoint["OutboundPaymentSelf"] = "OutboundPaymentSelf";
    Endpoint["OutboundPaymentList"] = "OutboundPaymentList";
    Endpoint["OutboundPaymentUpdate"] = "OutboundPaymentUpdate";
    Endpoint["OutboundPaymentBalanceSelf"] = "OutboundPaymentBalanceSelf";
    Endpoint["PartnerFeeList"] = "PartnerFeeList";
    Endpoint["PasswordResetTokenCreate"] = "PasswordResetTokenCreate";
    Endpoint["PasswordResetTokenUse"] = "PasswordResetTokenUse";
    Endpoint["PasswordResetTokenSelf"] = "PasswordResetTokenSelf";
    Endpoint["PayFlowIgnore"] = "PayFlowIgnore";
    Endpoint["PayerAuthorisationSelf"] = "PayerAuthorisationSelf";
    Endpoint["PayerAuthorisationCreate"] = "PayerAuthorisationCreate";
    Endpoint["PayerAuthorisationUpdate"] = "PayerAuthorisationUpdate";
    Endpoint["PayerAuthorisationSubmit"] = "PayerAuthorisationSubmit";
    Endpoint["PayerAuthorisationConfirm"] = "PayerAuthorisationConfirm";
    Endpoint["PayerAuthorisationPublicTokenCreate"] = "PayerAuthorisationPublicTokenCreate";
    Endpoint["PayerAuthorisationSessionTokenCreate"] = "PayerAuthorisationSessionTokenCreate";
    Endpoint["PayerFraudConfigurationCreate"] = "PayerFraudConfigurationCreate";
    Endpoint["PayerFraudConfigurationList"] = "PayerFraudConfigurationList";
    Endpoint["PayerFraudConfigurationUpdate"] = "PayerFraudConfigurationUpdate";
    Endpoint["PayerThemeList"] = "PayerThemeList";
    Endpoint["PayerThemeSelf"] = "PayerThemeSelf";
    Endpoint["PayerThemeDestroy"] = "PayerThemeDestroy";
    Endpoint["PayerThemeCreate"] = "PayerThemeCreate";
    Endpoint["PayerThemeUpdate"] = "PayerThemeUpdate";
    Endpoint["PayerThemeCreateForCreditor"] = "PayerThemeCreateForCreditor";
    Endpoint["PayerThemePreviewCreate"] = "PayerThemePreviewCreate";
    Endpoint["PaylinkList"] = "PaylinkList";
    Endpoint["PaylinkCreate"] = "PaylinkCreate";
    Endpoint["PaylinkSelf"] = "PaylinkSelf";
    Endpoint["PaylinkUpdate"] = "PaylinkUpdate";
    Endpoint["PaylinkDisable"] = "PaylinkDisable";
    Endpoint["PaymentCreate"] = "PaymentCreate";
    Endpoint["PaymentList"] = "PaymentList";
    Endpoint["PaymentSelf"] = "PaymentSelf";
    Endpoint["PaymentUpdate"] = "PaymentUpdate";
    Endpoint["PaymentCancel"] = "PaymentCancel";
    Endpoint["PaymentRetry"] = "PaymentRetry";
    Endpoint["PaymentAutoretryConfigurationList"] = "PaymentAutoretryConfigurationList";
    Endpoint["PaymentAutoretryConfigurationUpdate"] = "PaymentAutoretryConfigurationUpdate";
    Endpoint["PaymentLimitList"] = "PaymentLimitList";
    Endpoint["PaymentLimitUpdate"] = "PaymentLimitUpdate";
    Endpoint["PaymentLimitCreate"] = "PaymentLimitCreate";
    Endpoint["PaymentLookupCreate"] = "PaymentLookupCreate";
    Endpoint["PaymentRequestList"] = "PaymentRequestList";
    Endpoint["PaymentRequestSelf"] = "PaymentRequestSelf";
    Endpoint["PaymentRequestFlowCreate"] = "PaymentRequestFlowCreate";
    Endpoint["PayoutList"] = "PayoutList";
    Endpoint["PayoutSelf"] = "PayoutSelf";
    Endpoint["PayoutExport"] = "PayoutExport";
    Endpoint["PayoutRetry"] = "PayoutRetry";
    Endpoint["PayoutUpdate"] = "PayoutUpdate";
    Endpoint["PayoutItemList"] = "PayoutItemList";
    Endpoint["PennyTestSelf"] = "PennyTestSelf";
    Endpoint["PennyTestComplete"] = "PennyTestComplete";
    Endpoint["PermittedPayoutList"] = "PermittedPayoutList";
    Endpoint["PipeAccessTokenSelf"] = "PipeAccessTokenSelf";
    Endpoint["PlanList"] = "PlanList";
    Endpoint["PlanSelf"] = "PlanSelf";
    Endpoint["PlanCancel"] = "PlanCancel";
    Endpoint["PlanUpdate"] = "PlanUpdate";
    Endpoint["PlanCreate"] = "PlanCreate";
    Endpoint["PlanSubscribe"] = "PlanSubscribe";
    Endpoint["PlanNextChargeDates"] = "PlanNextChargeDates";
    Endpoint["PlanPlanSchedulers"] = "PlanPlanSchedulers";
    Endpoint["PlanSchedulerCreate"] = "PlanSchedulerCreate";
    Endpoint["PlanSchedulerUpdate"] = "PlanSchedulerUpdate";
    Endpoint["PlanSchedulerSelf"] = "PlanSchedulerSelf";
    Endpoint["PlanSchedulerCancel"] = "PlanSchedulerCancel";
    Endpoint["PricingScenarioList"] = "PricingScenarioList";
    Endpoint["ProspectCreate"] = "ProspectCreate";
    Endpoint["ProtectPlusMonitoringList"] = "ProtectPlusMonitoringList";
    Endpoint["PublicTokenList"] = "PublicTokenList";
    Endpoint["PublicTokenSelf"] = "PublicTokenSelf";
    Endpoint["PublicTokenDisable"] = "PublicTokenDisable";
    Endpoint["PublicTokenCreate"] = "PublicTokenCreate";
    Endpoint["PublishableAccessTokenCreate"] = "PublishableAccessTokenCreate";
    Endpoint["PublishableAccessTokenList"] = "PublishableAccessTokenList";
    Endpoint["PublishableAccessTokenSelf"] = "PublishableAccessTokenSelf";
    Endpoint["PublishableAccessTokenUpdate"] = "PublishableAccessTokenUpdate";
    Endpoint["PublishableAccessTokenDisable"] = "PublishableAccessTokenDisable";
    Endpoint["RateLimitedNotificationCreate"] = "RateLimitedNotificationCreate";
    Endpoint["RateLimitedNotificationList"] = "RateLimitedNotificationList";
    Endpoint["RedirectFlowCreate"] = "RedirectFlowCreate";
    Endpoint["RedirectFlowSelf"] = "RedirectFlowSelf";
    Endpoint["RedirectFlowComplete"] = "RedirectFlowComplete";
    Endpoint["RefundCreate"] = "RefundCreate";
    Endpoint["RefundList"] = "RefundList";
    Endpoint["RefundSelf"] = "RefundSelf";
    Endpoint["RefundUpdate"] = "RefundUpdate";
    Endpoint["RegisteredCompanyList"] = "RegisteredCompanyList";
    Endpoint["RegisteredCompanyLookupCreate"] = "RegisteredCompanyLookupCreate";
    Endpoint["RegistrationCreate"] = "RegistrationCreate";
    Endpoint["RememberCustomerDetailShow"] = "RememberCustomerDetailShow";
    Endpoint["RememberCustomerDetailDisable"] = "RememberCustomerDetailDisable";
    Endpoint["ReportingMetric"] = "ReportingMetric";
    Endpoint["RequestSigningKeyList"] = "RequestSigningKeyList";
    Endpoint["RequestSigningKeyCreate"] = "RequestSigningKeyCreate";
    Endpoint["RequestSigningKeySelf"] = "RequestSigningKeySelf";
    Endpoint["RequestSigningKeyDestroy"] = "RequestSigningKeyDestroy";
    Endpoint["RequiredActionList"] = "RequiredActionList";
    Endpoint["RequiredActionSelf"] = "RequiredActionSelf";
    Endpoint["RequiredActionAttachDocument"] = "RequiredActionAttachDocument";
    Endpoint["RequiredActionCheckDocument"] = "RequiredActionCheckDocument";
    Endpoint["RequiredActionConfirmDeposit"] = "RequiredActionConfirmDeposit";
    Endpoint["RequiredActionSubmitAchDetails"] = "RequiredActionSubmitAchDetails";
    Endpoint["RequiredVerificationList"] = "RequiredVerificationList";
    Endpoint["RestrictionList"] = "RestrictionList";
    Endpoint["RhinoBrfSelf"] = "RhinoBrfSelf";
    Endpoint["RiskActionList"] = "RiskActionList";
    Endpoint["RiskActionSelf"] = "RiskActionSelf";
    Endpoint["RiskActionCreate"] = "RiskActionCreate";
    Endpoint["RiskActionApprove"] = "RiskActionApprove";
    Endpoint["RiskActionCancel"] = "RiskActionCancel";
    Endpoint["RiskActionFail"] = "RiskActionFail";
    Endpoint["RiskAlertList"] = "RiskAlertList";
    Endpoint["RiskAlertAssign"] = "RiskAlertAssign";
    Endpoint["RiskAlertUnassign"] = "RiskAlertUnassign";
    Endpoint["RiskAlertTriggerList"] = "RiskAlertTriggerList";
    Endpoint["RiskAppAuthorisationList"] = "RiskAppAuthorisationList";
    Endpoint["RiskCreditorSummaryList"] = "RiskCreditorSummaryList";
    Endpoint["RiskLabelCreate"] = "RiskLabelCreate";
    Endpoint["RiskPaymentList"] = "RiskPaymentList";
    Endpoint["RiskProfileList"] = "RiskProfileList";
    Endpoint["RiskProfileSelf"] = "RiskProfileSelf";
    Endpoint["RiskProfileCreate"] = "RiskProfileCreate";
    Endpoint["RiskProfileQuestionList"] = "RiskProfileQuestionList";
    Endpoint["RiskUserSelf"] = "RiskUserSelf";
    Endpoint["ScenarioSimulatorList"] = "ScenarioSimulatorList";
    Endpoint["ScenarioSimulatorRun"] = "ScenarioSimulatorRun";
    Endpoint["SchemeIdentifierCreate"] = "SchemeIdentifierCreate";
    Endpoint["SchemeIdentifierList"] = "SchemeIdentifierList";
    Endpoint["SchemeIdentifierSelf"] = "SchemeIdentifierSelf";
    Endpoint["SchemeIdentifierUpdate"] = "SchemeIdentifierUpdate";
    Endpoint["SearchSearch"] = "SearchSearch";
    Endpoint["SelfServiceTicketCreate"] = "SelfServiceTicketCreate";
    Endpoint["SessionTokenCreate"] = "SessionTokenCreate";
    Endpoint["SsoConfigSelf"] = "SsoConfigSelf";
    Endpoint["SubscriptionCreate"] = "SubscriptionCreate";
    Endpoint["SubscriptionList"] = "SubscriptionList";
    Endpoint["SubscriptionSelf"] = "SubscriptionSelf";
    Endpoint["SubscriptionUpdate"] = "SubscriptionUpdate";
    Endpoint["SubscriptionPause"] = "SubscriptionPause";
    Endpoint["SubscriptionResume"] = "SubscriptionResume";
    Endpoint["SubscriptionCancel"] = "SubscriptionCancel";
    Endpoint["SubscriptionNextChargeDates"] = "SubscriptionNextChargeDates";
    Endpoint["SubscriptionAmendmentList"] = "SubscriptionAmendmentList";
    Endpoint["SupportContactList"] = "SupportContactList";
    Endpoint["SupportContactSelf"] = "SupportContactSelf";
    Endpoint["SupportContactCreate"] = "SupportContactCreate";
    Endpoint["SupportContactUpdate"] = "SupportContactUpdate";
    Endpoint["SupportedCountryList"] = "SupportedCountryList";
    Endpoint["TaxRateList"] = "TaxRateList";
    Endpoint["TaxRateSelf"] = "TaxRateSelf";
    Endpoint["TemporaryAccessTokenCreate"] = "TemporaryAccessTokenCreate";
    Endpoint["TemporaryAccessTokenDisableSelf"] = "TemporaryAccessTokenDisableSelf";
    Endpoint["TemporaryAccessTokenCreateForOrganisation"] = "TemporaryAccessTokenCreateForOrganisation";
    Endpoint["TestSignatureTestSignature"] = "TestSignatureTestSignature";
    Endpoint["TestWebhookCreate"] = "TestWebhookCreate";
    Endpoint["TransferredMandateTransferredMandates"] = "TransferredMandateTransferredMandates";
    Endpoint["UpgradeCreate"] = "UpgradeCreate";
    Endpoint["UpgradeList"] = "UpgradeList";
    Endpoint["UpgradeEnable"] = "UpgradeEnable";
    Endpoint["UpgradeDisable"] = "UpgradeDisable";
    Endpoint["UpgradeToggle"] = "UpgradeToggle";
    Endpoint["UserCreate"] = "UserCreate";
    Endpoint["UserList"] = "UserList";
    Endpoint["UserShowSelf"] = "UserShowSelf";
    Endpoint["UserSelf"] = "UserSelf";
    Endpoint["UserSecurityQuestionsSelf"] = "UserSecurityQuestionsSelf";
    Endpoint["UserSecurityQuestions"] = "UserSecurityQuestions";
    Endpoint["UserUpdateSelf"] = "UserUpdateSelf";
    Endpoint["UserUpdate"] = "UserUpdate";
    Endpoint["UserEnable"] = "UserEnable";
    Endpoint["UserDisable"] = "UserDisable";
    Endpoint["UserCreateOnfidoToken"] = "UserCreateOnfidoToken";
    Endpoint["UserVerifySelf"] = "UserVerifySelf";
    Endpoint["UserEnforcePasswordReset"] = "UserEnforcePasswordReset";
    Endpoint["UserListOrganisations"] = "UserListOrganisations";
    Endpoint["UserListOrganisationsSelf"] = "UserListOrganisationsSelf";
    Endpoint["UserListNotificationsSelf"] = "UserListNotificationsSelf";
    Endpoint["V3MigrationPrimaryAdminUserList"] = "V3MigrationPrimaryAdminUserList";
    Endpoint["VerificationList"] = "VerificationList";
    Endpoint["VerificationSelf"] = "VerificationSelf";
    Endpoint["VerificationApprove"] = "VerificationApprove";
    Endpoint["VerificationPendingResponse"] = "VerificationPendingResponse";
    Endpoint["VerificationRedemand"] = "VerificationRedemand";
    Endpoint["VerificationUpload"] = "VerificationUpload";
    Endpoint["VerificationFail"] = "VerificationFail";
    Endpoint["VerificationDetailCreate"] = "VerificationDetailCreate";
    Endpoint["VerificationDetailList"] = "VerificationDetailList";
    Endpoint["VerificationDocumentTokensCreate"] = "VerificationDocumentTokensCreate";
    Endpoint["VerificationJourneyList"] = "VerificationJourneyList";
    Endpoint["WebhookList"] = "WebhookList";
    Endpoint["WebhookSelf"] = "WebhookSelf";
    Endpoint["WebhookRetry"] = "WebhookRetry";
    Endpoint["WebhookEndpointCreate"] = "WebhookEndpointCreate";
    Endpoint["WebhookEndpointList"] = "WebhookEndpointList";
    Endpoint["WebhookEndpointSelf"] = "WebhookEndpointSelf";
    Endpoint["WebhookEndpointDisable"] = "WebhookEndpointDisable";
    Endpoint["WebhookEndpointUpdate"] = "WebhookEndpointUpdate";
    Endpoint["XeroAuthorisationCreate"] = "XeroAuthorisationCreate";
    Endpoint["XeroAuthorisationTakeControl"] = "XeroAuthorisationTakeControl";
    Endpoint["XeroMigrationSelf"] = "XeroMigrationSelf";
})(Endpoint || (Endpoint = {}));
const endpoints = {
    [Endpoint.AcceptFeesSelf]: compile("oauth/accept_fees"),
    [Endpoint.AcceptMerchantAgreementSelf]: compile("oauth/accept_merchant_agreement"),
    [Endpoint.AccessTokenCreate]: compile("access_tokens"),
    [Endpoint.AccessTokenList]: compile("access_tokens"),
    [Endpoint.AccessTokenSelf]: compile("access_tokens/:accessTokenId"),
    [Endpoint.AccessTokenUpdate]: compile("access_tokens/:accessTokenId"),
    [Endpoint.AccessTokenDisable]: compile("access_tokens/:accessTokenId/actions/disable"),
    [Endpoint.AccountUpgradeTokenCreate]: compile("account_upgrade_tokens"),
    [Endpoint.ActivationDiscountVersionList]: compile("activation_discount_versions"),
    [Endpoint.AddressDetailSelf]: compile("address_lookups/:addressDetailId"),
    [Endpoint.AddressLookupCreate]: compile("address_lookups"),
    [Endpoint.AdminAccessTokenCreate]: compile("admin_access_tokens"),
    [Endpoint.AdminAppRevenueShareAgreementCreate]: compile("admin_app_revenue_share_agreements"),
    [Endpoint.AdminAppRevenueShareAgreementSelf]: compile("admin_app_revenue_share_agreements/:adminAppRevenueShareAgreementId"),
    [Endpoint.AdminBankAccountBlacklist]: compile("admin/bank_accounts/:adminBankAccountId/actions/blacklist"),
    [Endpoint.AdminCommentCreate]: compile("admin_comments"),
    [Endpoint.AdminCommentUpdate]: compile("admin_comments"),
    [Endpoint.AdminCommentList]: compile("admin_comments"),
    [Endpoint.AdminCreditorUpdateMerchantCategoryCode]: compile("admin/creditors/:adminCreditorId/actions/update_merchant_category_code"),
    [Endpoint.AdminCreditorUpdateSubtype]: compile("admin/creditors/:adminCreditorId/actions/update_subtype"),
    [Endpoint.AdminCreditorUpdateOnlinePresenceUrl]: compile("admin/creditors/:adminCreditorId/actions/update_online_presence_url"),
    [Endpoint.AdminCreditorDetailSelf]: compile("admin/creditor_details/:adminCreditorDetailId"),
    [Endpoint.AdminFraudMetricsSelf]: compile("admin/fraud/metrics"),
    [Endpoint.AdminFraudMetricsBankNetworkList]: compile("admin/fraud/metrics/bank_network"),
    [Endpoint.AdminFraudMetricsFraudScoresList]: compile("admin/fraud/metrics/fraud_scores"),
    [Endpoint.AdminFraudMetricsIpAddressesList]: compile("admin/fraud/metrics/ip_addresses"),
    [Endpoint.AdminFraudMetricsIpAddressesNetworkList]: compile("admin/fraud/metrics/ip_addresses_network"),
    [Endpoint.AdminFraudMetricsMandatesList]: compile("admin/fraud/metrics/mandates"),
    [Endpoint.AdminFraudMetricsMonthlyMandateSummaryList]: compile("admin/fraud/metrics/monthly_mandate_summary"),
    [Endpoint.AdminFraudMetricsPaymentOverviewList]: compile("admin/fraud/metrics/payment_overview"),
    [Endpoint.AdminSearchSearch]: compile("admin_search"),
    [Endpoint.AdminTaskList]: compile("admin/tasks"),
    [Endpoint.AdminTaskTrigger]: compile("admin/tasks/trigger"),
    [Endpoint.AmlAlertTriggerTypeList]: compile("enterprise/admin/aml_alert_trigger_types"),
    [Endpoint.AmlScoreSelf]: compile("admin/aml_scores/:amlScoreId"),
    [Endpoint.AppList]: compile("apps"),
    [Endpoint.AppSelf]: compile("apps/:appId"),
    [Endpoint.AppCreate]: compile("apps"),
    [Endpoint.AppUpdate]: compile("apps/:appId"),
    [Endpoint.AppRequestReview]: compile("apps/:appId/actions/request_review"),
    [Endpoint.AppApprove]: compile("apps/:appId/actions/approve"),
    [Endpoint.AppDisable]: compile("apps/:appId/actions/disable"),
    [Endpoint.AppNonOauthEnabled]: compile("apps/:appId/actions/non_oauth_enabled"),
    [Endpoint.AppAccessTokenCreate]: compile("app_access_tokens"),
    [Endpoint.AppAuthorisationRevoke]: compile("app_authorisations/:appAuthorisationId/actions/revoke"),
    [Endpoint.AppAuthorisationSelf]: compile("app_authorisations/:appAuthorisationId"),
    [Endpoint.AppAuthorisationList]: compile("app_authorisations"),
    [Endpoint.AppFeeAgreementSelf]: compile("admin/app_fee_agreements/:appFeeAgreementId"),
    [Endpoint.AppFeeAgreementList]: compile("admin/app_fee_agreements"),
    [Endpoint.AppFeeAgreementCreate]: compile("admin/app_fee_agreements"),
    [Endpoint.AuthenticationFactorList]: compile("authentication_factors"),
    [Endpoint.AuthenticationFactorSelf]: compile("authentication_factors/:authenticationFactorId"),
    [Endpoint.AuthenticationFactorCreate]: compile("authentication_factors"),
    [Endpoint.AuthenticationFactorTrigger]: compile("authentication_factors/:authenticationFactorId/actions/trigger"),
    [Endpoint.AuthenticationFactorVerify]: compile("authentication_factors/:authenticationFactorId/actions/verify"),
    [Endpoint.AuthenticationFactorDisable]: compile("authentication_factors/:authenticationFactorId/actions/disable"),
    [Endpoint.AuthenticationFactorDisableOrgUser]: compile("authentication_factors/:authenticationFactorId/actions/disable_org_user"),
    [Endpoint.AuthorisationLinkList]: compile("authorisation_links"),
    [Endpoint.AuthorisationRequestCreate]: compile("authorisation_requests"),
    [Endpoint.AuthorisationRequestList]: compile("authorisation_requests"),
    [Endpoint.AuthorisationRequestCancel]: compile("authorisation_requests/:authorisationRequestId/actions/cancel"),
    [Endpoint.AvailableCreditorRefundAmountList]: compile("available_creditor_refund_amounts"),
    [Endpoint.AvailableEventDetailsList]: compile("events/available_event_details"),
    [Endpoint.BalanceList]: compile("balances"),
    [Endpoint.BankAccountDetailSelf]: compile("bank_account_details/:bankAccountDetailId"),
    [Endpoint.BankAccountUpdateRequestCreate]: compile("bank_account_update_requests"),
    [Endpoint.BankAccountUpdateRequestInitialise]: compile("bank_account_update_requests/initialise"),
    [Endpoint.BankAccountUpdateRequestComplete]: compile("bank_account_update_requests/:bankAccountUpdateRequestId/complete"),
    [Endpoint.BankAccountUpdateRequestDetails]: compile("bank_account_update_requests/:bankAccountUpdateRequestId/details"),
    [Endpoint.BankAccountUpdateRequestShow]: compile("bank_account_update_requests/:bankAccountUpdateRequestId"),
    [Endpoint.BankAuthorisationCreate]: compile("bank_authorisations"),
    [Endpoint.BankAuthorisationSelf]: compile("bank_authorisations/:bankAuthorisationId"),
    [Endpoint.BankAuthorisationLookup]: compile("bank_authorisations/lookup"),
    [Endpoint.BankAuthorisationAuthorise]: compile("bank_authorisations/:bankAuthorisationId/actions/authorise"),
    [Endpoint.BankAuthorisationExit]: compile("bank_authorisations/:bankAuthorisationId/actions/exit"),
    [Endpoint.BankAuthorisationTrackVisit]: compile("bank_authorisations/:bankAuthorisationId/actions/track_visit"),
    [Endpoint.BankDetailsLookupCreate]: compile("bank_details_lookups"),
    [Endpoint.BankNetworkMetricsSelf]: compile("admin/fraud/bank_network_metrics"),
    [Endpoint.BillingContactList]: compile("billing_contacts"),
    [Endpoint.BillingContactSelf]: compile("billing_contacts/:billingContactId"),
    [Endpoint.BillingContactCreate]: compile("billing_contacts"),
    [Endpoint.BillingContactUpdate]: compile("billing_contacts/:billingContactId"),
    [Endpoint.BillingRedirectFlowCreate]: compile("billing_redirect_flows"),
    [Endpoint.BillingRedirectFlowComplete]: compile("billing_redirect_flows/:billingRedirectFlowId/actions/complete"),
    [Endpoint.BillingRequestCreate]: compile("billing_requests"),
    [Endpoint.BillingRequestCollectCustomerDetails]: compile("billing_requests/:billingRequestId/actions/collect_customer_details"),
    [Endpoint.BillingRequestCollectBankAccount]: compile("billing_requests/:billingRequestId/actions/collect_bank_account"),
    [Endpoint.BillingRequestConfirmPayerDetails]: compile("billing_requests/:billingRequestId/actions/confirm_payer_details"),
    [Endpoint.BillingRequestFulfil]: compile("billing_requests/:billingRequestId/actions/fulfil"),
    [Endpoint.BillingRequestCancel]: compile("billing_requests/:billingRequestId/actions/cancel"),
    [Endpoint.BillingRequestList]: compile("billing_requests"),
    [Endpoint.BillingRequestSelf]: compile("billing_requests/:billingRequestId"),
    [Endpoint.BillingRequestNotify]: compile("billing_requests/:billingRequestId/actions/notify"),
    [Endpoint.BillingRequestFallback]: compile("billing_requests/:billingRequestId/actions/fallback"),
    [Endpoint.BillingRequestChooseCurrency]: compile("billing_requests/:billingRequestId/actions/choose_currency"),
    [Endpoint.BillingRequestUpdate]: compile("billing_requests/:billingRequestId"),
    [Endpoint.BillingRequestSelectInstitution]: compile("billing_requests/:billingRequestId/actions/select_institution"),
    [Endpoint.BillingRequestCreateWithActions]: compile("billing_requests/create_with_actions"),
    [Endpoint.BillingRequestCollectAmount]: compile("billing_requests/:billingRequestId/actions/collect_amount"),
    [Endpoint.BillingRequestFlowCreate]: compile("billing_request_flows"),
    [Endpoint.BillingRequestFlowSelf]: compile("billing_request_flows/:billingRequestFlowId"),
    [Endpoint.BillingRequestFlowInitialise]: compile("billing_request_flows/:billingRequestFlowId/actions/initialise"),
    [Endpoint.BillingRequestFlowResume]: compile("billing_request_flows/:billingRequestFlowId/actions/resume"),
    [Endpoint.BillingRequestFlowTrack]: compile("billing_request_flows/:billingRequestFlowId/actions/track"),
    [Endpoint.BillingRequestFlowExit]: compile("billing_request_flows/:billingRequestFlowId/actions/exit"),
    [Endpoint.BillingRequestTemplateList]: compile("billing_request_templates"),
    [Endpoint.BillingRequestTemplateSelf]: compile("billing_request_templates/:billingRequestTemplateId"),
    [Endpoint.BillingRequestTemplateCreate]: compile("billing_request_templates"),
    [Endpoint.BillingRequestTemplateUpdate]: compile("billing_request_templates/:billingRequestTemplateId"),
    [Endpoint.BillingRequestTemplateUse]: compile("billing_request_templates/:billingRequestTemplateId/actions/use"),
    [Endpoint.BlockCreate]: compile("blocks"),
    [Endpoint.BlockSelf]: compile("blocks/:blockId"),
    [Endpoint.BlockList]: compile("blocks"),
    [Endpoint.BlockDisable]: compile("blocks/:blockId/actions/disable"),
    [Endpoint.BlockEnable]: compile("blocks/:blockId/actions/enable"),
    [Endpoint.BlockBlockByRef]: compile("blocks/block_by_ref"),
    [Endpoint.BrowserPerformanceMetricCreate]: compile("browser_performance_metrics"),
    [Endpoint.BulkChangeRequestCreate]: compile("bulk_change_requests"),
    [Endpoint.CapitalIntegrationList]: compile("capital_integrations"),
    [Endpoint.ChargebackSelf]: compile("chargebacks/:chargebackId"),
    [Endpoint.ChargebackList]: compile("chargebacks"),
    [Endpoint.ChargebackSubmit]: compile("chargebacks/:chargebackId/submit"),
    [Endpoint.ChargebackChallengeCreate]: compile("chargeback_challenge"),
    [Endpoint.ChargebackChallengeSelf]: compile("chargeback_challenge/:chargebackChallengeId"),
    [Endpoint.ChargebackChallengeSubmit]: compile("chargeback_challenge/:chargebackChallengeId/submit"),
    [Endpoint.ChargebackEvidenceDelete]: compile("chargeback_evidences/:chargebackEvidenceId"),
    [Endpoint.ConnectBankAccountAisAuthorisationUrl]: compile("connect_bank_account/ais_authorisation_url"),
    [Endpoint.ConnectBankAccountAddUnmatchedBankAccount]: compile("connect_bank_account/add_unmatched_bank_account"),
    [Endpoint.ContractList]: compile("contracts"),
    [Endpoint.ContractCreate]: compile("contracts"),
    [Endpoint.CookieBasedTokenCreate]: compile("cookie_based_tokens"),
    [Endpoint.CreditorCreate]: compile("creditors"),
    [Endpoint.CreditorList]: compile("creditors"),
    [Endpoint.CreditorSelf]: compile("creditors/:creditorId"),
    [Endpoint.CreditorUpdate]: compile("creditors/:creditorId"),
    [Endpoint.CreditorFlagAsRisky]: compile("creditors/:creditorId/actions/flag_as_risky"),
    [Endpoint.CreditorCloseAccount]: compile("creditors/:creditorId/actions/close_account"),
    [Endpoint.CreditorClearNegativeBalance]: compile("creditors/:creditorId/actions/clear_negative_balance"),
    [Endpoint.CreditorCancelUnsubmittedPayments]: compile("creditors/:creditorId/actions/cancel_unsubmitted_payments"),
    [Endpoint.CreditorCancelAllSubscriptions]: compile("creditors/:creditorId/actions/cancel_all_subscriptions"),
    [Endpoint.CreditorChangePayoutIntervalSetting]: compile("creditors/:creditorId/actions/change_payout_interval_setting"),
    [Endpoint.CreditorChangeFlexiblePayoutSettings]: compile("creditors/:creditorId/actions/change_flexible_payout_settings"),
    [Endpoint.CreditorRequestFlexiblePayoutOverride]: compile("creditors/:creditorId/actions/request_flexible_payout_override"),
    [Endpoint.CreditorClearFlexiblePayoutOverride]: compile("creditors/:creditorId/actions/clear_flexible_payout_override"),
    [Endpoint.CreditorChargeBackAllPayments]: compile("creditors/:creditorId/actions/charge_back_all_payments"),
    [Endpoint.CreditorUpdateHoldingPeriod]: compile("creditors/:creditorId/actions/update_holding_period"),
    [Endpoint.CreditorUpdateMerchantCategoryCode]: compile("creditors/:creditorId/actions/update_merchant_category_code"),
    [Endpoint.CreditorBalanceList]: compile("creditor_balances"),
    [Endpoint.CreditorBankAccountCreate]: compile("creditor_bank_accounts"),
    [Endpoint.CreditorBankAccountList]: compile("creditor_bank_accounts"),
    [Endpoint.CreditorBankAccountSelf]: compile("creditor_bank_accounts/:creditorBankAccountId"),
    [Endpoint.CreditorBankAccountDisable]: compile("creditor_bank_accounts/:creditorBankAccountId/actions/disable"),
    [Endpoint.CreditorDetailList]: compile("creditor_details"),
    [Endpoint.CreditorDetailSelf]: compile("creditor_details/:creditorDetailId"),
    [Endpoint.CreditorDetailUpdate]: compile("creditor_details/:creditorDetailId"),
    [Endpoint.CreditorRestrictionList]: compile("admin/creditor_restrictions"),
    [Endpoint.CreditorRestrictionStatusList]: compile("creditor_restriction_statuses"),
    [Endpoint.CreditorVerticalList]: compile("creditor_verticals"),
    [Endpoint.CurrencyExchangeRateList]: compile("currency_exchange_rates"),
    [Endpoint.CustomPaymentPagePaymentFlowLookup]: compile("custom_payment_pages/payment_flow_lookup"),
    [Endpoint.CustomPaymentPageTrack]: compile("custom_payment_pages/track"),
    [Endpoint.CustomerCreate]: compile("customers"),
    [Endpoint.CustomerList]: compile("customers"),
    [Endpoint.CustomerSelf]: compile("customers/:customerId"),
    [Endpoint.CustomerUpdate]: compile("customers/:customerId"),
    [Endpoint.CustomerCancel]: compile("customers/:customerId/actions/cancel"),
    [Endpoint.CustomerRemove]: compile("customers/:customerId"),
    [Endpoint.CustomerApprovalSelf]: compile("customer_approvals/:customerApprovalId"),
    [Endpoint.CustomerApprovalGrant]: compile("customer_approvals/:customerApprovalId/actions/grant"),
    [Endpoint.CustomerApprovalDeny]: compile("customer_approvals/:customerApprovalId/actions/deny"),
    [Endpoint.CustomerBankAccountCreate]: compile("customer_bank_accounts"),
    [Endpoint.CustomerBankAccountList]: compile("customer_bank_accounts"),
    [Endpoint.CustomerBankAccountSelf]: compile("customer_bank_accounts/:customerBankAccountId"),
    [Endpoint.CustomerBankAccountUpdate]: compile("customer_bank_accounts/:customerBankAccountId"),
    [Endpoint.CustomerBankAccountDisable]: compile("customer_bank_accounts/:customerBankAccountId/actions/disable"),
    [Endpoint.CustomerBankAccountTokenCreatePost]: compile("customer_bank_account_tokens"),
    [Endpoint.CustomerBankAccountTokenSelf]: compile("customer_bank_account_tokens/:customerBankAccountTokenId"),
    [Endpoint.CustomerEmailVerificationCreate]: compile("customer_email_verifications"),
    [Endpoint.CustomerEmailVerificationVerify]: compile("customer_email_verifications/:customerEmailVerificationId/verify"),
    [Endpoint.CustomerNotificationList]: compile("customer_notifications"),
    [Endpoint.CustomerNotificationHandle]: compile("customer_notifications/:customerNotificationId/actions/handle"),
    [Endpoint.CustomerNotificationPermissionCreate]: compile("customer_notification_permissions"),
    [Endpoint.CustomerNotificationPermissionUpdate]: compile("customer_notification_permissions/:customerNotificationPermissionId"),
    [Endpoint.CustomerNotificationPermissionRevoke]: compile("customer_notification_permissions/:customerNotificationPermissionId"),
    [Endpoint.CustomerNotificationPermissionList]: compile("customer_notification_permissions"),
    [Endpoint.CustomerSearchSearch]: compile("customer_search"),
    [Endpoint.DeveloperContactList]: compile("developer_contacts"),
    [Endpoint.DeveloperContactCreate]: compile("developer_contacts"),
    [Endpoint.DeveloperContactSelf]: compile("developer_contacts/:developerContactId"),
    [Endpoint.DeveloperContactUpdate]: compile("developer_contacts/:developerContactId"),
    [Endpoint.DropinConfigurationList]: compile("dropin_configuration"),
    [Endpoint.EmailVerificationCreate]: compile("email_verifications"),
    [Endpoint.EstimatePaymentFeeList]: compile("estimate_payment_fees"),
    [Endpoint.EstimatePayoutList]: compile("estimate_payout"),
    [Endpoint.EventList]: compile("events"),
    [Endpoint.EventSelf]: compile("events/:eventId"),
    [Endpoint.EventSimulationTrigger]: compile("event_simulations"),
    [Endpoint.ExportSelf]: compile("exports/:exportId"),
    [Endpoint.ExportCreate]: compile("exports"),
    [Endpoint.ExportList]: compile("exports"),
    [Endpoint.FeeAgreementSelf]: compile("admin/fee_agreements/:feeAgreementId"),
    [Endpoint.FeeAgreementList]: compile("admin/fee_agreements"),
    [Endpoint.FeeAgreementCreate]: compile("admin/fee_agreements"),
    [Endpoint.FeeAgreementDestroy]: compile("admin/fee_agreements/:feeAgreementId"),
    [Endpoint.FeeAgreementTemplateList]: compile("fee_agreement_templates"),
    [Endpoint.FeeDiscountList]: compile("fee_discounts"),
    [Endpoint.FeeDiscountCreate]: compile("fee_discounts"),
    [Endpoint.FlagsList]: compile("flags"),
    [Endpoint.FraudAlertTriggerTypeList]: compile("enterprise/admin/fraud_alert_trigger_types"),
    [Endpoint.ImportList]: compile("imports"),
    [Endpoint.ImportSelf]: compile("imports/:importId"),
    [Endpoint.ImportCreate]: compile("imports"),
    [Endpoint.ImportErrorFile]: compile("imports/:importId/actions/error_file"),
    [Endpoint.ImportRequestProcess]: compile("imports/:importId/actions/request_process"),
    [Endpoint.ImportProcess]: compile("imports/:importId/actions/process"),
    [Endpoint.ImportCancel]: compile("imports/:importId/actions/cancel"),
    [Endpoint.ImportEntryList]: compile("import_entries"),
    [Endpoint.ImportTemplateCreate]: compile("import_templates"),
    [Endpoint.ImportTemplateShow]: compile("import_templates/:importTemplateId"),
    [Endpoint.ImportUploadTokenCreate]: compile("import_upload_tokens"),
    [Endpoint.InstalmentScheduleCreateWithDates]: compile("instalment_schedules"),
    [Endpoint.InstalmentScheduleCreateWithSchedule]: compile("instalment_schedules"),
    [Endpoint.InstalmentScheduleList]: compile("instalment_schedules"),
    [Endpoint.InstalmentScheduleSelf]: compile("instalment_schedules/:instalmentScheduleId"),
    [Endpoint.InstalmentScheduleUpdate]: compile("instalment_schedules/:instalmentScheduleId"),
    [Endpoint.InstalmentScheduleCancel]: compile("instalment_schedules/:instalmentScheduleId/actions/cancel"),
    [Endpoint.InstalmentTemplateSelf]: compile("instalment_templates/:instalmentTemplateId"),
    [Endpoint.InstalmentTemplateList]: compile("instalment_templates"),
    [Endpoint.InstalmentTemplateCreate]: compile("instalment_templates"),
    [Endpoint.InstalmentTemplateSubscribe]: compile("instalment_templates/:instalmentTemplateId/actions/subscribe"),
    [Endpoint.InstitutionList]: compile("institutions"),
    [Endpoint.InstitutionListForBillingRequest]: compile("billing_requests/:institutionId/institutions"),
    [Endpoint.IntelligentRetryStatisticList]: compile("intelligent_retry_statistics"),
    [Endpoint.InvoicePdfCreate]: compile("invoice_pdfs"),
    [Endpoint.IpNetworkMetricsSelf]: compile("admin/fraud/ip_network_metrics"),
    [Endpoint.LogoCreateForCreditor]: compile("branding/logos"),
    [Endpoint.LogoCreate]: compile("logos"),
    [Endpoint.LogoSelf]: compile("logos/:logoId"),
    [Endpoint.MandateCreate]: compile("mandates"),
    [Endpoint.MandateList]: compile("mandates"),
    [Endpoint.MandateSelf]: compile("mandates/:mandateId"),
    [Endpoint.MandateUpdate]: compile("mandates/:mandateId"),
    [Endpoint.MandateCancel]: compile("mandates/:mandateId/actions/cancel"),
    [Endpoint.MandateReinstate]: compile("mandates/:mandateId/actions/reinstate"),
    [Endpoint.MandateMove]: compile("mandates/:mandateId/actions/move"),
    [Endpoint.MandateFundsAvailability]: compile("mandates/:mandateId/funds_availability"),
    [Endpoint.MandateImportCreate]: compile("mandate_imports"),
    [Endpoint.MandateImportSelf]: compile("mandate_imports/:mandateImportId"),
    [Endpoint.MandateImportSubmit]: compile("mandate_imports/:mandateImportId/actions/submit"),
    [Endpoint.MandateImportCancel]: compile("mandate_imports/:mandateImportId/actions/cancel"),
    [Endpoint.MandateImportEntryCreate]: compile("mandate_import_entries"),
    [Endpoint.MandateImportEntryList]: compile("mandate_import_entries"),
    [Endpoint.MandateMigrationOptOut]: compile("mandate_migrations/:mandateMigrationId/actions/opt_out"),
    [Endpoint.MandateMigrationOptIn]: compile("mandate_migrations/:mandateMigrationId/actions/opt_in"),
    [Endpoint.MandateMigrationSelf]: compile("mandate_migrations/:mandateMigrationId"),
    [Endpoint.MandatePdfCreate]: compile("mandate_pdfs"),
    [Endpoint.MerchantCategoryCodePredict]: compile("merchant_category_codes/predict"),
    [Endpoint.MfaEnforcementEnforce]: compile("mfa_enforcement/enforce"),
    [Endpoint.NegativeBalanceLimitList]: compile("negative_balance_limits"),
    [Endpoint.NegativeBalanceLimitCreate]: compile("negative_balance_limits"),
    [Endpoint.OauthActiveFlowSelf]: compile("oauth/active_flow"),
    [Endpoint.OauthCreateForOrganisationOauthCreateForOrganisation]: compile("oauth/create_for_organisation/:oauthCreateForOrganisationId"),
    [Endpoint.OauthFeesSelf]: compile("oauth/fees"),
    [Endpoint.OauthListOrganisationsSelfOauthListOrganisationsSelf]: compile("oauth/list_organisations_self"),
    [Endpoint.OnboardingStepList]: compile("onboarding_steps"),
    [Endpoint.OnfidoSdkTokenCreate]: compile("onfido_sdk_tokens"),
    [Endpoint.OrganisationSelf]: compile("organisations/:organisationId"),
    [Endpoint.OrganisationUpdateSelf]: compile("organisations/self"),
    [Endpoint.OrganisationRequestPackage]: compile("organisations/:organisationId/actions/request_package"),
    [Endpoint.OrganisationChangePackage]: compile("organisations/:organisationId/actions/change_package"),
    [Endpoint.OrganisationApplySchemeIdentifier]: compile("organisations/:organisationId/actions/apply_scheme_identifier"),
    [Endpoint.OrganisationRemoveSchemeIdentifier]: compile("organisations/:organisationId/actions/remove_scheme_identifier"),
    [Endpoint.OrganisationEnforceMfa]: compile("organisations/enforce_mfa"),
    [Endpoint.OrganisationAcceptTermsAndConditions]: compile("organisations/accept_terms_and_conditions"),
    [Endpoint.OrganisationPublicKeyUrl]: compile("organisations/public_key_url"),
    [Endpoint.OrganisationProposedLink]: compile("organisations/proposed_link"),
    [Endpoint.OrganisationApproveProposedLink]: compile("organisations/approve_proposed_link"),
    [Endpoint.OrganisationRejectProposedLink]: compile("organisations/reject_proposed_link"),
    [Endpoint.OrganisationAuthorisationList]: compile("organisation_authorisations"),
    [Endpoint.OrganisationBillingRequestCreate]: compile("organisation_billing_request/create"),
    [Endpoint.OrganisationBillingRequestFulfil]: compile("organisation_billing_request/fulfil"),
    [Endpoint.OutOfCycleReviewSelf]: compile("admin/out_of_cycle_reviews/:outOfCycleReviewId"),
    [Endpoint.OutOfCycleReviewUpdate]: compile("admin/out_of_cycle_reviews"),
    [Endpoint.OutboundPaymentCreate]: compile("outbound_payments"),
    [Endpoint.OutboundPaymentWithdraw]: compile("outbound_payments/withdrawal"),
    [Endpoint.OutboundPaymentCancel]: compile("outbound_payments/:outboundPaymentId/actions/cancel"),
    [Endpoint.OutboundPaymentApprove]: compile("outbound_payments/:outboundPaymentId/actions/approve"),
    [Endpoint.OutboundPaymentSelf]: compile("outbound_payments/:outboundPaymentId"),
    [Endpoint.OutboundPaymentList]: compile("outbound_payments"),
    [Endpoint.OutboundPaymentUpdate]: compile("outbound_payments/:outboundPaymentId"),
    [Endpoint.OutboundPaymentBalanceSelf]: compile("outbound_payment_balances/:outboundPaymentBalanceId"),
    [Endpoint.PartnerFeeList]: compile("partner_fees"),
    [Endpoint.PasswordResetTokenCreate]: compile("password_reset_tokens"),
    [Endpoint.PasswordResetTokenUse]: compile("password_reset_tokens/:passwordResetTokenId/actions/use"),
    [Endpoint.PasswordResetTokenSelf]: compile("password_reset_tokens/:passwordResetTokenId"),
    [Endpoint.PayFlowIgnore]: compile("flow/redirect_flow_id"),
    [Endpoint.PayerAuthorisationSelf]: compile("payer_authorisations/:payerAuthorisationId"),
    [Endpoint.PayerAuthorisationCreate]: compile("payer_authorisations"),
    [Endpoint.PayerAuthorisationUpdate]: compile("payer_authorisations/:payerAuthorisationId"),
    [Endpoint.PayerAuthorisationSubmit]: compile("payer_authorisations/:payerAuthorisationId/actions/submit"),
    [Endpoint.PayerAuthorisationConfirm]: compile("payer_authorisations/:payerAuthorisationId/actions/confirm"),
    [Endpoint.PayerAuthorisationPublicTokenCreate]: compile("payer_authorisation_public_tokens"),
    [Endpoint.PayerAuthorisationSessionTokenCreate]: compile("payer_authorisation_session_tokens"),
    [Endpoint.PayerFraudConfigurationCreate]: compile("protect_plus/configuration"),
    [Endpoint.PayerFraudConfigurationList]: compile("protect_plus/configuration"),
    [Endpoint.PayerFraudConfigurationUpdate]: compile("protect_plus/configuration/:payerFraudConfigurationId"),
    [Endpoint.PayerThemeList]: compile("payer_themes"),
    [Endpoint.PayerThemeSelf]: compile("payer_themes/:payerThemeId"),
    [Endpoint.PayerThemeDestroy]: compile("payer_themes/:payerThemeId"),
    [Endpoint.PayerThemeCreate]: compile("payer_themes"),
    [Endpoint.PayerThemeUpdate]: compile("payer_themes/:payerThemeId"),
    [Endpoint.PayerThemeCreateForCreditor]: compile("branding/payer_themes"),
    [Endpoint.PayerThemePreviewCreate]: compile("payer_theme_previews"),
    [Endpoint.PaylinkList]: compile("paylinks"),
    [Endpoint.PaylinkCreate]: compile("paylinks"),
    [Endpoint.PaylinkSelf]: compile("paylinks/:paylinkId"),
    [Endpoint.PaylinkUpdate]: compile("paylinks/:paylinkId"),
    [Endpoint.PaylinkDisable]: compile("paylinks/:paylinkId/actions/disable"),
    [Endpoint.PaymentCreate]: compile("payments"),
    [Endpoint.PaymentList]: compile("payments"),
    [Endpoint.PaymentSelf]: compile("payments/:paymentId"),
    [Endpoint.PaymentUpdate]: compile("payments/:paymentId"),
    [Endpoint.PaymentCancel]: compile("payments/:paymentId/actions/cancel"),
    [Endpoint.PaymentRetry]: compile("payments/:paymentId/actions/retry"),
    [Endpoint.PaymentAutoretryConfigurationList]: compile("payment_autoretry_configurations"),
    [Endpoint.PaymentAutoretryConfigurationUpdate]: compile("payment_autoretry_configurations"),
    [Endpoint.PaymentLimitList]: compile("payment_limits"),
    [Endpoint.PaymentLimitUpdate]: compile("payment_limits/:paymentLimitId"),
    [Endpoint.PaymentLimitCreate]: compile("payment_limits"),
    [Endpoint.PaymentLookupCreate]: compile("payment_lookups"),
    [Endpoint.PaymentRequestList]: compile("payment_requests"),
    [Endpoint.PaymentRequestSelf]: compile("payment_requests/:paymentRequestId"),
    [Endpoint.PaymentRequestFlowCreate]: compile("payment_request_flows"),
    [Endpoint.PayoutList]: compile("payouts"),
    [Endpoint.PayoutSelf]: compile("payouts/:payoutId"),
    [Endpoint.PayoutExport]: compile("payouts/:payoutId/actions/export"),
    [Endpoint.PayoutRetry]: compile("payouts/:payoutId/actions/retry"),
    [Endpoint.PayoutUpdate]: compile("payouts/:payoutId"),
    [Endpoint.PayoutItemList]: compile("payout_items"),
    [Endpoint.PennyTestSelf]: compile("penny_tests/:pennyTestId"),
    [Endpoint.PennyTestComplete]: compile("penny_tests/:pennyTestId/actions/complete"),
    [Endpoint.PermittedPayoutList]: compile("admin/permitted_payouts"),
    [Endpoint.PipeAccessTokenSelf]: compile("pipe_access_tokens/:pipeAccessTokenId"),
    [Endpoint.PlanList]: compile("plans"),
    [Endpoint.PlanSelf]: compile("plans/:planId"),
    [Endpoint.PlanCancel]: compile("plans/:planId/actions/cancel"),
    [Endpoint.PlanUpdate]: compile("plans/:planId"),
    [Endpoint.PlanCreate]: compile("plans"),
    [Endpoint.PlanSubscribe]: compile("plans/:planId/actions/subscribe"),
    [Endpoint.PlanNextChargeDates]: compile("plans/:planId/next_charge_dates"),
    [Endpoint.PlanPlanSchedulers]: compile("plans/:planId/plan_schedulers"),
    [Endpoint.PlanSchedulerCreate]: compile("plan_schedulers/pause/:planSchedulerId"),
    [Endpoint.PlanSchedulerUpdate]: compile("plan_schedulers/:planSchedulerId"),
    [Endpoint.PlanSchedulerSelf]: compile("plan_schedulers/:planSchedulerId"),
    [Endpoint.PlanSchedulerCancel]: compile("plan_schedulers/:planSchedulerId/cancel"),
    [Endpoint.PricingScenarioList]: compile("pricing_scenarios"),
    [Endpoint.ProspectCreate]: compile("prospects"),
    [Endpoint.ProtectPlusMonitoringList]: compile("protect_plus/monitoring/:protectPlusMonitoringId"),
    [Endpoint.PublicTokenList]: compile("public_tokens"),
    [Endpoint.PublicTokenSelf]: compile("public_tokens/:publicTokenId"),
    [Endpoint.PublicTokenDisable]: compile("public_tokens/:publicTokenId/actions/disable"),
    [Endpoint.PublicTokenCreate]: compile("public_tokens"),
    [Endpoint.PublishableAccessTokenCreate]: compile("publishable_access_tokens"),
    [Endpoint.PublishableAccessTokenList]: compile("publishable_access_tokens"),
    [Endpoint.PublishableAccessTokenSelf]: compile("publishable_access_tokens/:publishableAccessTokenId"),
    [Endpoint.PublishableAccessTokenUpdate]: compile("publishable_access_tokens/:publishableAccessTokenId"),
    [Endpoint.PublishableAccessTokenDisable]: compile("publishable_access_tokens/:publishableAccessTokenId/actions/disable"),
    [Endpoint.RateLimitedNotificationCreate]: compile("rate_limited_notifications"),
    [Endpoint.RateLimitedNotificationList]: compile("rate_limited_notifications"),
    [Endpoint.RedirectFlowCreate]: compile("redirect_flows"),
    [Endpoint.RedirectFlowSelf]: compile("redirect_flows/:redirectFlowId"),
    [Endpoint.RedirectFlowComplete]: compile("redirect_flows/:redirectFlowId/actions/complete"),
    [Endpoint.RefundCreate]: compile("refunds"),
    [Endpoint.RefundList]: compile("refunds"),
    [Endpoint.RefundSelf]: compile("refunds/:refundId"),
    [Endpoint.RefundUpdate]: compile("refunds/:refundId"),
    [Endpoint.RegisteredCompanyList]: compile("registered_companies"),
    [Endpoint.RegisteredCompanyLookupCreate]: compile("registered_company_lookups"),
    [Endpoint.RegistrationCreate]: compile("registrations"),
    [Endpoint.RememberCustomerDetailShow]: compile("remember_customer_details"),
    [Endpoint.RememberCustomerDetailDisable]: compile("remember_customer_details/actions/disable"),
    [Endpoint.ReportingMetric]: compile("reporting/:reportingId"),
    [Endpoint.RequestSigningKeyList]: compile("request_signing_keys"),
    [Endpoint.RequestSigningKeyCreate]: compile("request_signing_keys"),
    [Endpoint.RequestSigningKeySelf]: compile("request_signing_keys/:requestSigningKeyId"),
    [Endpoint.RequestSigningKeyDestroy]: compile("request_signing_keys/:requestSigningKeyId"),
    [Endpoint.RequiredActionList]: compile("required_actions"),
    [Endpoint.RequiredActionSelf]: compile("required_actions/:requiredActionId"),
    [Endpoint.RequiredActionAttachDocument]: compile("required_actions/:requiredActionId/actions/attach_document"),
    [Endpoint.RequiredActionCheckDocument]: compile("required_actions/:requiredActionId/actions/check_document"),
    [Endpoint.RequiredActionConfirmDeposit]: compile("required_actions/:requiredActionId/actions/confirm_deposit"),
    [Endpoint.RequiredActionSubmitAchDetails]: compile("required_actions/:requiredActionId/actions/submit_ach_details"),
    [Endpoint.RequiredVerificationList]: compile("required_verifications"),
    [Endpoint.RestrictionList]: compile("restrictions"),
    [Endpoint.RhinoBrfSelf]: compile("fraud/rhino-brf"),
    [Endpoint.RiskActionList]: compile("admin/risk_actions"),
    [Endpoint.RiskActionSelf]: compile("admin/risk_actions/:riskActionId"),
    [Endpoint.RiskActionCreate]: compile("admin/risk_actions"),
    [Endpoint.RiskActionApprove]: compile("admin/risk_actions/:riskActionId/actions/approve"),
    [Endpoint.RiskActionCancel]: compile("admin/risk_actions/:riskActionId/actions/cancel"),
    [Endpoint.RiskActionFail]: compile("admin/risk_actions/:riskActionId/actions/fail"),
    [Endpoint.RiskAlertList]: compile("admin/risk_alerts"),
    [Endpoint.RiskAlertAssign]: compile("admin/risk_alerts/:riskAlertId/actions/assign"),
    [Endpoint.RiskAlertUnassign]: compile("admin/risk_alerts/:riskAlertId/actions/assign"),
    [Endpoint.RiskAlertTriggerList]: compile("admin/risk_alert_triggers"),
    [Endpoint.RiskAppAuthorisationList]: compile("admin/risk/app_authorisations"),
    [Endpoint.RiskCreditorSummaryList]: compile("admin/risk_creditor_summaries"),
    [Endpoint.RiskLabelCreate]: compile("admin/risk_labels"),
    [Endpoint.RiskPaymentList]: compile("admin/risk_payments"),
    [Endpoint.RiskProfileList]: compile("admin/risk_profiles"),
    [Endpoint.RiskProfileSelf]: compile("admin/risk_profiles/:riskProfileId"),
    [Endpoint.RiskProfileCreate]: compile("admin/risk_profiles"),
    [Endpoint.RiskProfileQuestionList]: compile("admin/risk_profile_questions"),
    [Endpoint.RiskUserSelf]: compile("admin/risk_users/:riskUserId"),
    [Endpoint.ScenarioSimulatorList]: compile("scenario_simulators"),
    [Endpoint.ScenarioSimulatorRun]: compile("scenario_simulators/:scenarioSimulatorId/actions/run"),
    [Endpoint.SchemeIdentifierCreate]: compile("scheme_identifiers"),
    [Endpoint.SchemeIdentifierList]: compile("scheme_identifiers"),
    [Endpoint.SchemeIdentifierSelf]: compile("scheme_identifiers/:schemeIdentifierId"),
    [Endpoint.SchemeIdentifierUpdate]: compile("scheme_identifiers/:schemeIdentifierId"),
    [Endpoint.SearchSearch]: compile("search"),
    [Endpoint.SelfServiceTicketCreate]: compile("sso/self_service_tickets"),
    [Endpoint.SessionTokenCreate]: compile("session_tokens"),
    [Endpoint.SsoConfigSelf]: compile("sso/config"),
    [Endpoint.SubscriptionCreate]: compile("subscriptions"),
    [Endpoint.SubscriptionList]: compile("subscriptions"),
    [Endpoint.SubscriptionSelf]: compile("subscriptions/:subscriptionId"),
    [Endpoint.SubscriptionUpdate]: compile("subscriptions/:subscriptionId"),
    [Endpoint.SubscriptionPause]: compile("subscriptions/:subscriptionId/actions/pause"),
    [Endpoint.SubscriptionResume]: compile("subscriptions/:subscriptionId/actions/resume"),
    [Endpoint.SubscriptionCancel]: compile("subscriptions/:subscriptionId/actions/cancel"),
    [Endpoint.SubscriptionNextChargeDates]: compile("subscriptions/:subscriptionId/next_charge_dates"),
    [Endpoint.SubscriptionAmendmentList]: compile("subscription_amendments"),
    [Endpoint.SupportContactList]: compile("support_contacts"),
    [Endpoint.SupportContactSelf]: compile("support_contacts/:supportContactId"),
    [Endpoint.SupportContactCreate]: compile("support_contacts"),
    [Endpoint.SupportContactUpdate]: compile("support_contacts/:supportContactId"),
    [Endpoint.SupportedCountryList]: compile("supported_countries"),
    [Endpoint.TaxRateList]: compile("tax_rates"),
    [Endpoint.TaxRateSelf]: compile("tax_rates/:taxRateId"),
    [Endpoint.TemporaryAccessTokenCreate]: compile("temporary_access_tokens"),
    [Endpoint.TemporaryAccessTokenDisableSelf]: compile("temporary_access_tokens/actions/disable_self"),
    [Endpoint.TemporaryAccessTokenCreateForOrganisation]: compile("temporary_access_tokens/actions/create_for_organisation"),
    [Endpoint.TestSignatureTestSignature]: compile("test_signature"),
    [Endpoint.TestWebhookCreate]: compile("test_webhooks"),
    [Endpoint.TransferredMandateTransferredMandates]: compile("transferred_mandates/:transferredMandateId"),
    [Endpoint.UpgradeCreate]: compile("upgrades"),
    [Endpoint.UpgradeList]: compile("upgrades"),
    [Endpoint.UpgradeEnable]: compile("upgrades/:upgradeId/actions/enable"),
    [Endpoint.UpgradeDisable]: compile("upgrades/:upgradeId/actions/disable"),
    [Endpoint.UpgradeToggle]: compile("upgrades/:upgradeId/actions/toggle"),
    [Endpoint.UserCreate]: compile("users"),
    [Endpoint.UserList]: compile("users"),
    [Endpoint.UserShowSelf]: compile("users/self"),
    [Endpoint.UserSelf]: compile("users/:userId"),
    [Endpoint.UserSecurityQuestionsSelf]: compile("users/self/security-questions"),
    [Endpoint.UserSecurityQuestions]: compile("users/security-questions/:userId"),
    [Endpoint.UserUpdateSelf]: compile("users/self"),
    [Endpoint.UserUpdate]: compile("users/:userId"),
    [Endpoint.UserEnable]: compile("users/:userId/actions/enable"),
    [Endpoint.UserDisable]: compile("users/:userId/actions/disable"),
    [Endpoint.UserCreateOnfidoToken]: compile("users/self/onfido_token"),
    [Endpoint.UserVerifySelf]: compile("users/self/verify"),
    [Endpoint.UserEnforcePasswordReset]: compile("users/self/enforce_password_reset"),
    [Endpoint.UserListOrganisations]: compile("users/list-organisations/:userId"),
    [Endpoint.UserListOrganisationsSelf]: compile("users/self/list-organisations"),
    [Endpoint.UserListNotificationsSelf]: compile("users/self/list-notifications"),
    [Endpoint.V3MigrationPrimaryAdminUserList]: compile("migration_primary_admin_users"),
    [Endpoint.VerificationList]: compile("admin/verifications"),
    [Endpoint.VerificationSelf]: compile("admin/verifications/:verificationId"),
    [Endpoint.VerificationApprove]: compile("admin/verifications/:verificationId/actions/approve"),
    [Endpoint.VerificationPendingResponse]: compile("admin/verifications/:verificationId/actions/pending_response"),
    [Endpoint.VerificationRedemand]: compile("admin/verifications/:verificationId/actions/redemand"),
    [Endpoint.VerificationUpload]: compile("admin/verifications/:verificationId/actions/upload"),
    [Endpoint.VerificationFail]: compile("admin/verifications/:verificationId/actions/fail"),
    [Endpoint.VerificationDetailCreate]: compile("verification_details"),
    [Endpoint.VerificationDetailList]: compile("verification_details"),
    [Endpoint.VerificationDocumentTokensCreate]: compile("verification_documents"),
    [Endpoint.VerificationJourneyList]: compile("verification_journeys"),
    [Endpoint.WebhookList]: compile("webhooks"),
    [Endpoint.WebhookSelf]: compile("webhooks/:webhookId"),
    [Endpoint.WebhookRetry]: compile("webhooks/:webhookId/actions/retry"),
    [Endpoint.WebhookEndpointCreate]: compile("webhook_endpoints"),
    [Endpoint.WebhookEndpointList]: compile("webhook_endpoints"),
    [Endpoint.WebhookEndpointSelf]: compile("webhook_endpoints/:webhookEndpointId"),
    [Endpoint.WebhookEndpointDisable]: compile("webhook_endpoints/:webhookEndpointId"),
    [Endpoint.WebhookEndpointUpdate]: compile("webhook_endpoints/:webhookEndpointId"),
    [Endpoint.XeroAuthorisationCreate]: compile("xero_authorisations"),
    [Endpoint.XeroAuthorisationTakeControl]: compile("xero_authorisations/take_control"),
    [Endpoint.XeroMigrationSelf]: compile("organisations/:xeroMigrationId/actions/toggle_xero_migration"),
};
export const getEndpointURL = (route, params) => {
    return endpoints[route](params);
};
